import { render, staticRenderFns } from "./NotificationListSent.vue?vue&type=template&id=6b0c4542&scoped=true"
import script from "./NotificationListSent.vue?vue&type=script&lang=js"
export * from "./NotificationListSent.vue?vue&type=script&lang=js"
import style0 from "./NotificationListSent.vue?vue&type=style&index=0&id=6b0c4542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c4542",
  null
  
)

export default component.exports